import BaseRepository from './base.repository';

/**
 * Subscription Repository
 * Handles API communication for subscription
 */
class SubscriptionRepository extends BaseRepository {
  constructor() {
    super('subscription');
  }

  /**
   * Get current subscription
   * @returns {Promise}
   */
  getCurrent() {
    return this.client.get('/current');
  }

  /**
   * Get my features (based on current subscription)
   * @returns {Promise}
   */
  getMyFeatures() {
    return this.client.get('/my-features');
  }

  /**
   * Check access to a specific feature
   * @param {string} featureName - Feature name to check
   * @returns {Promise}
   */
  checkAccess(featureName) {
    return this.client.get('/check-access', { feature_name: featureName });
  }
}

export default new SubscriptionRepository();

